/* eslint-disable react/jsx-pascal-case */
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { BrowserView, MobileView } from 'react-device-detect';
import Login from "./pages/Basic/Login";
import Register from "./pages/Basic/Register";
import Nav from "./components/Nav/Nav";
import Sale from "./pages/Sale/Sale";
import SaleLog from './pages/SaleLog/SaleLog';
import ItemList from './pages/Itemmanagement/ItemList';
import ItemLog from './pages/Itemmanagement/ItemLog';
import Delivery from './pages/DeliveryManagement/Delivery';
import Statitics from './pages/Statitics/Statitics';
import UserManagement from './pages/UserManagement/UserManagement';
import NotPage from "./pages/Basic/NotPage";
import MonitorSize from "./components/MonitorSize";
import StoreUserManagement from "./pages/StoreUserManagement/StoreUserManagement";
import User from "./pages/User/User";
import Order_list from "./pages/OrderManagement/Order_list";
import Order_order from "./pages/OrderManagement/Order_order";
import Order_state from "./pages/OrderManagement/Order_state";
import Bc from "./pages/BcBeMe/Bc";
import Be from "./pages/BcBeMe/Be";
import Me from "./pages/BcBeMe/Me";
import BcBeMeCancel from "./pages/BcBeMe/BcBeMeCancel";
import Chart_1 from "./pages/SaleChart/Chart_1";
import Chart_2 from "./pages/SaleChart/Chart_2";
import Point_main from "./pages/PointStore/Point_main";

function App() {
    
  return (
    <>

      <BrowserView>
        <div className="max-w-full flex justify-center items-center">
          <div className="md:inline hidden max-w-[2000px] w-full">
            <div className=" sticky top-0 z-50">
              <Nav />
            </div>
            <Routes>
              <Route path="/login" element={ <Login />} />
              <Route path="/register" element={ <Register />} />
              <Route path="/sale" element={ <Sale/> } />
              <Route path="/salelog" element={ <SaleLog />} />
              <Route path="/itemmanagement/itemlist" element={ <ItemList />} />
              <Route path="/itemmanagement/itemlog" element={ <ItemLog />} />
              <Route path="/salechart/chart_1" element={ <Chart_1 />} />
              <Route path="/salechart/chart_2" element={ <Chart_2 />} />
              <Route path="/order/order" element={ <Order_order />} />
              <Route path="/order/list" element={ <Order_list />} />
              <Route path="/order/state" element={ <Order_state />} />
              <Route path="/bcbeme/bc" element={ <Bc />} />
              <Route path="/bcbeme/be" element={ <Be />} />
              <Route path="/bcbeme/me" element={ <Me />} />
              <Route path="/bcbeme/cancel" element={ <BcBeMeCancel />} />
              <Route path="/delivery" element={ <Delivery />} />
              <Route path="/statitics" element={ <Statitics />} />
              <Route path="/usermanagement" element={ <UserManagement />} />
              <Route path="/storeusermanagement" element={ <StoreUserManagement />} />
              <Route path="/user" element={ <User />} />
              <Route path="/pointstore" element={ <Point_main />} />
              <Route path="/*" element={<NotPage/>} />
            </Routes>
          </div>
          <div className="md:hidden w-full flex flex-col gap-3 h-screen justify-center items-center text-md text-center">
            <MonitorSize />
          </div>
        </div>
      </BrowserView>

      <MobileView>
        <>
        {/* <div>
          <NotMobile />
        </div> */}
          <Nav/>
          <Routes>
            <Route path="/login" element={ <Login />} />
            <Route path="/register" element={ <Register />} />
            <Route path="/sale" element={ <Sale/> } />
            <Route path="/salelog" element={ <SaleLog />} />
            <Route path="/itemmanagement/itemlist" element={ <ItemList />} />
            <Route path="/itemmanagement/itemlog" element={ <ItemLog />} />
            <Route path="/salechart/chart_1" element={ <Chart_1 />} />
            <Route path="/salechart/chart_2" element={ <Chart_2 />} />
            <Route path="/order/order" element={ <Order_order />} />
            <Route path="/order/list" element={ <Order_list />} />
            <Route path="/order/state" element={ <Order_state />} />
            <Route path="/bcbeme/bc" element={ <Bc />} />
            <Route path="/bcbeme/be" element={ <Be />} />
            <Route path="/bcbeme/me" element={ <Me />} />
            <Route path="/bcbeme/cancel" element={ <BcBeMeCancel />} />
            <Route path="/delivery" element={ <Delivery />} />
            <Route path="/statitics" element={ <Statitics />} />
            <Route path="/usermanagement" element={ <UserManagement />} />
            <Route path="/storeusermanagement" element={ <StoreUserManagement />} />
            <Route path="/user" element={ <User />} />
            <Route path="/pointstore" element={ <Point_main />} />
            <Route path="/*" element={<NotPage/>} />
          </Routes>
        </>
      </MobileView>
    
    </>
  );
}

export default App;